<template>
<div class="map-details">
	<grid flat>
		<grid-item size="1/2" class="key">Sector:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.sector.name }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Region:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.region.name }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Area information:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.area_information }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Land Area:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.land_area }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Land Allocation:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.land_allocation }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Land with Opportunity:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.land_opportunity }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Utilities:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.utilities }}
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Policy Objectives:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ opportunityDetail.policy_objectives }}
			</span>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
	props: {
		opportunity: {
			type: Object
		}
	},
	computed: {
		opportunityDetail() {
			return {
				...this.opportunity,
				'area_information': `
					Ate district, nearby football stadium
					Estadio Monumental and Monumental Amusement Center`,
				'land_area': '5200m2',
				'land_allocation': 'Sale of Land',
				'land_opportunity': 'Yes',
				'utilities': 'Available',
				'policy_objectives': 'Urban regeneration; Job creation'
			}
		}
	}
}
</script>

<style lang="scss">
.map-details {
	text-align: left;
	color: #fff;
	font-size: 12px;
	font-weight: 200;
	padding-right: 16px;
	
	.key {
		font-weight: 500;
	}
	.value {
		display: flex;

		span {
			align-self: flex-end;
		}
	}
}
</style>
